var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895427 0.89543 0 2 0H144C145.105 0 146 0.89543 146 2V141C146 142.105 145.105 143 144 143H2C0.895432 143 0 142.105 0 141V2Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.268 100.853C93.3049 94.4523 87.5625 89.0494 87.5625 77.4812C87.5625 70.5388 93.4483 66.0396 95.4546 60.0897C97.4611 54.1398 98.6217 47.0954 99.5864 41.9712C100.551 36.8469 100.935 34.8649 101.459 29.4051C102.101 22.5911 97.437 5 72.5 5C47.5705 5 42.8919 22.5911 43.5478 29.4051C44.0725 34.8649 44.4579 36.8471 45.4206 41.9712C46.3834 47.0953 47.5327 54.1394 49.5378 60.0897C51.5428 66.04 57.437 70.5388 57.437 77.4812C57.437 89.0494 51.6946 94.4521 33.7316 100.853C15.7033 107.268 4 113.593 4 118.062V139H141V118.062C141 113.601 129.289 107.275 111.268 100.853Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElUser);
export default __webpack_public_path__ + "static/media/el_user.ff8696dc7801d67e95444a7d620b4900.svg";
export { ForwardRef as ReactComponent };